import { Children, FC, Fragment, isValidElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import './cares-page-header.scss';

type CaresPageHeaderProps = {
  homepage: string;
  activepage: string;
  page: string;
  actions?: ReactNode;
  homepageHref?: string;
  activepageHref?: string;
};

const renderBreadcrumbItem = (label: string, href?: string) => (
  <li className="breadcrumb-item">
    {href ? <Link to={href}>{label}</Link> : <span>{label}</span>}
  </li>
);

const CaresPageHeader: FC<CaresPageHeaderProps> = ({
  homepage,
  activepage,
  page,
  actions,
  homepageHref,
  activepageHref,
}) => {
  const hasActions = Boolean(
    actions
    && (!isValidElement(actions) || actions.type !== Fragment || Children.count(actions.props.children) > 0)
  );
  const breadcrumbItems = [
    { label: homepage, href: homepageHref },
    ...(activepage !== homepage || activepageHref ? [{ label: activepage, href: activepageHref }] : []),
    { label: page },
  ].filter((item, index, items) => {
    if (index === 0) {
      return true;
    }

    const previousItem = items[index - 1];
    return item.label !== previousItem.label || item.href !== previousItem.href;
  });

  return (
    <>
      <div className="cares-page-header page-header-breadcrumb" data-cares-page-breadcrumb>
        <div className="cares-page-header__inner d-flex align-items-center justify-content-between gap-2">
          <h1 className="visually-hidden">{page}</h1>
          <nav aria-label="breadcrumb" className="cares-page-header__nav">
            <ol className="breadcrumb cares-page-header__breadcrumb mb-0">
              {breadcrumbItems.map((item, index) =>
                index === breadcrumbItems.length - 1 ? (
                  <li className="breadcrumb-item active" aria-current="page" key={`${item.label}-${index}`}>
                    {item.label}
                  </li>
                ) : (
                  <Fragment key={`${item.label}-${index}`}>{renderBreadcrumbItem(item.label, item.href)}</Fragment>
                )
              )}
            </ol>
          </nav>
        </div>
      </div>
      {hasActions ? (
        <section className="card custom-card cares-page-hero" aria-labelledby="cares-page-action-title">
          <div className="card-body d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
            <h2 className="mb-0" id="cares-page-action-title">
              {page}
            </h2>
            <div className="btn-list d-flex align-items-center flex-wrap gap-2">{actions}</div>
          </div>
        </section>
      ) : null}
    </>
  );
};

export default CaresPageHeader;
